<template>
  <div class="floors" v-show="itemsList.length">
    <!--TITLE S-->
    <div class="floors-title">
      <h2>{{ title }}</h2>
      <div class="title-items">
        <ul>
          <li
            v-for="(item, index) in itemsList"
            :key="index"
            :class="currentItem===item.title?'active':''"
            @click="currentItem=item.title"
            v-show="itemsList[item.title]!=''"
          >{{ item.title }}</li>
        </ul>
      </div>
    </div>
    <!--TITLE E-->
    <div class="floors-content">
      <!--CONTENT S-->
      <div class="content">
        <div
          v-for="(info, index) in itemsList"
          :key="index"
          v-show="currentItem===info.title"
        >
          <loading v-if="!itemsList"></loading>
          <a
            v-for="item in info.content"
            :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`"
            :key="item.Id"
          >
            <span class="coursename" :title="item.FullName">{{ item.Name }}</span>
            <span class="place" :title="item.LearnPlace"><i></i>{{ item.LearnPlace }}</span>
            <span class="time"><i></i>{{ item.StartDate.split('T')[0] }} 至 {{ item.EndDate.split('T')[0] }}</span>
            <span class="price">￥{{ item.Price }}</span>
            <span class="btn"><button>立即报名</button></span>
          </a>
        </div>
      </div>
      <!--CONTENT E-->
      <!--NEWS S-->
      <div class="article" v-if="typeId">
        <div class="AD-articleContent">
          <h4 class="articleContentTitle"><em></em>{{ newsTitle }}
            <i><img src="http://images.xdf.cn/cms20150819/zuixinban/images/course_hot.jpg" alt="HOT"></i>
          </h4>
          <ul class="articleContentList">
            <li v-for="(item, index) in hotList" :key="item.aid">
              <i class="articleNumber" :class="index < 3 ? 'hotNews': ''">{{ index + 1 }}</i>
              <a :href="item.url" :title="item.title">{{ item.title }}</a>
            </li>
          </ul>
        </div>
        <div class="articleAd" v-if="adCode">
          <ad-model :adCode="adCode"></ad-model>
        </div>
      </div>
      <!--NEWS E-->
    </div>
  </div>
</template>

<script>
import AdModel from '@/common-components/AdModel'
import Loading from '@/common-components/Loading'
import { getArticle } from 'js/getArticle.js'
export default {
  name: 'FloorFull',
  components: {
    AdModel,
    Loading
  },
  props: ['title', 'adCode', 'itemsList', 'typeId', 'newsTitle'],
  data () {
    return {
      currentItem: String,
      hotList: []
    }
  },
  created () {
    setTimeout(() => {
      if (typeof this.typeId === 'number') {
        this.getHotListData(this.typeId)
      }
    }, 20)
  },
  computed: {
    hotArticleId () {
      return this.typeId
    },
    list () {
      return this.itemsList
    }
  },
  watch: {
    hotArticleId (newVal, oldVal) {
      this.currentItem = this.itemsList[0] ? this.itemsList[0].title : ''
      this.getHotListData(newVal)
    },
    list (newVal) {
      this.currentItem = this.itemsList[0] ? this.itemsList[0].title : ''
    }
  },
  methods: {
    getHotListData (typeId) {
      getArticle(typeId, 5, '').then(response => {
        this.hotList = response
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.articleContentTitle
  flex: 2
  font-size: 15px
  color: #4a4a4a
  line-height: 35px
  em
    width: 4px
    height: 16px
    top: 3px
    position: relative
    display: inline-block
    margin-right: 10px
    background-color: $articleIcon
  i
    position: $abs
.floors
  width: 1200px
  height: 350px
  margin: 18px auto
  display: flex
  flex-direction: column
  .floors-title
    min-height: 38px
    height: 38px
    line-height: 38px
    padding-left: 12px
    border-bottom: 2px solid #98dfd2
    display: flex
    h2
      font-size: 18px
      flex: 1
    .title-items
      flex: 4
      ul
        li
          float: $fl
          color: #606060
          font-size: 14px
          padding: 0 20px
          cursor: pointer
        .active
          background: #fff
          color: $themeColor
          height: 40px
          position: relative
          top: -2px
          border-left: 1px solid #a5e1d6
          border-right: 1px solid #a5e1d6
          border-top: 2px solid $themeColor
  .floors-content
    flex: 1
    display: flex
    .content
      flex: 10
      padding-right: 10px
      a
        display: flex
        cursor: pointer
        height: 60px
        line-height: 60px
        border: 1px solid transparent
        border-bottom-color: #eee
        color: #8e8e8e
        overflow: hidden
        &:hover
          background: #f4fcfc
          border-color: #cbe9e9
          overflow: hidden
          button
            background: $themeColor
            color: #fff
        span
          flex: 3
          text-align: center
          button
            flex: 1
            border: 1px solid #d0eae8
            border-radius: 2px
            background: #f4fcfc
            color: $themeColor
            padding: 4px 18px
            font-size: 16px
            margin-top: 12px
        .coursename
          font-size: 13px
          color: #333
          text-align: left
          padding: 0 10px
          width: 226.19px
          display: block
        .place
          padding: 0 16px
          position: relative
          text-align: left
          width: 226.19px
          display: block
          i
            width: 14px
            height: 14px
            left: 0
            top: 50%
            margin-top: -7px
            display: block
            position: absolute
            background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat -178px -63px
        .time
          flex: 2
          padding: 0 16px
          position: relative
          text-align: left
          width: 150.8px
          display: block
          i
            width: 12px
            height: 14px
            left: 1px
            top: 50%
            margin-top: -7px
            display: block
            position: absolute
            background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat -216px -63px
        .price
          flex: 1
          color: #ff7011
          font-size: 18px
          width: 75.4px
          display: block
        .btn
          width: 150.8px
          display: block
          flex: 2
    .article
      flex: 3
      display: flex
      padding: 11px 0
      flex-direction: column
      .AD-articleContent
        flex: 2
        display: flex
        padding-left: 14px
        flex-direction: column
        ul
          flex: 10
          display: flex
          flex-direction: column
          li
            flex: 1
            width: 226px
            height: 29px
            line-height: 29px
            a
              width: 90%
              color: #666
              ellipsis()
              &:hover
                color: $themeColor
          .articleNumber
            width: 14px
            height: 14px
            border-radius: 2px
            display: inline-block
            text-align: center
            line-height: 14px
            color: #fff
            margin-right: 5px
            background-color: #cacaca
            font-size: 12px
            float: left
            position: relative
            top: 6px
          .hotNews
            background-color: #ff7011
      .articleAd
        flex: 1
</style>



// WEBPACK FOOTER //
// src/pages/middleschool/components/Floorfull.vue